import * as React from 'react'
import NextLink from 'next/link'
import styled from 'styled-components'

const Wrapper = styled.div`
  @media not screen and (max-width: 1280px) {
    position: relative;
    padding: 50px 0;
    background: #171414;
    .inner {
      padding: 60px 140px 68px 140px;
    }
    .left {
      width: 310px;
      .logo {
        gap: 8px;
        div {
          padding: 4px 4px 0 4px;
          width: 48px;
          height: 48px;
        }
        h2 {
          padding-right: 1rem;
          font-size: 16px;
          font-style: italic;
          font-weight: 900;
          text-transform: uppercase;
          background: linear-gradient(135deg, #fd8259 0%, #f04340 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      p {
        margin-left: -16px;
        color: rgba(255, 255, 255, 0.45);
        font-size: 12px;
        line-height: 16px;
        transform: scale(0.9);
      }
    }
    .right {
      gap: 64px;
      h4 {
        margin-bottom: 18px;
        color: rgba(255, 201, 177, 1);
        font-size: 12px;
        font-weight: 600;
      }
      p {
        color: rgba(255, 255, 255, 0.45);
        font-size: 12px;
        font-weight: 700;
      }
      a + p {
        margin-top: 9px;
      }
      p + p {
        margin-top: 9px;
      }
      div {
        gap: 13px;
      }
      img {
        width: 28px;
        height: 28px;
        user-select: none;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover {
          opacity: 0.4;
        }
      }
    }
    .divider {
      margin: 0;
      border: none;
      width: 100%;
      height: 1px;
      background: #272a2e;
    }
    .front,
    .back {
      position: absolute;
      top: 0;
      margin: 0;
      border: none;
      width: 1px;
      height: 100%;
      background: #272a2e;
    }
    .front {
      left: 48px;
    }
    .back {
      right: 48px;
    }
  }
  @media screen and (max-width: 1280px) {
    position: relative;
    /* margin-bottom: 50px;
    padding: 16px 0; */
    padding: 16px 0 66px 0;
    background: #171414;
    .inner {
      flex-direction: column;
      padding: 24px 40px 32px 40px;
    }
    .left {
      .logo {
        gap: 8px;
        div {
          padding: 4px 4px 0 4px;
          width: 48px;
          height: 48px;
        }
        h2 {
          padding-right: 1rem;
          font-size: 16px;
          font-style: italic;
          font-weight: 900;
          text-transform: uppercase;
          background: linear-gradient(135deg, #fd8259 0%, #f04340 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      p {
        margin-left: -16px;
        color: rgba(255, 255, 255, 0.45);
        font-size: 12px;
        line-height: 16px;
        transform: scale(0.9);
      }
    }
    .right {
      flex-direction: column;
      h4 {
        margin: 32px 0 20px 0;
        color: rgba(255, 201, 177, 1);
        font-size: 20px;
        font-weight: 500;
      }
      p {
        color: rgba(255, 255, 255, 0.45);
        font-size: 20px;
        font-weight: 500;
      }
      a + p {
        margin-top: 20px;
      }
      p + p {
        margin-top: 20px;
      }
      div {
        gap: 24px;
      }
      img {
        width: 28px;
        height: 28px;
        user-select: none;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .divider {
      margin: 0;
      border: none;
      width: 100%;
      height: 1px;
      background: #272a2e;
    }
    .front,
    .back {
      position: absolute;
      top: 0;
      margin: 0;
      border: none;
      width: 1px;
      height: 100%;
      background: #272a2e;
    }
    .front {
      left: 16px;
    }
    .back {
      right: 16px;
    }
  }
`

const FooterNew = () => {
  return (
    <Wrapper>
      <hr className="front" />
      <hr className="divider" />
      <div className="inner flex flex-row items-start justify-between">
        <div className="left">
          <div className="logo flex flex-row items-center justify-start">
            <div>
              <img src="/newImages/home/logo.png" alt="icon" />
            </div>
            <h2>AGNI</h2>
          </div>
          <p>High-Capital Efficiency AMM-based DEX & Launchpad</p>
        </div>
        <div className="right flex flex-row items-start justify-end">
          <div>
            <h4>Developer</h4>
            <NextLink href="https://agni-finance.gitbook.io/agni/" target="_blank">
              <p>Documents</p>
            </NextLink>
            {/* <p>Contact us</p>
            <p>Audits</p> */}
          </div>
          <div>
            <h4>Community</h4>
            <div className="flex flex-row items-start justify-start">
              <NextLink href="https://twitter.com/Agnidex" target="_blank">
                <img src="/newImages/launchpad/icon-community_twitter.svg" alt="icon" />
              </NextLink>
              <NextLink href="https://medium.com/@Agnidex" target="_blank">
                <img src="/newImages/launchpad/icon-community_medium.svg" alt="icon" />
              </NextLink>
              <NextLink href="https://discord.gg/H3YrfAkrGc" target="_blank">
                <img src="/newImages/launchpad/icon-community_discord.svg" alt="icon" />
              </NextLink>
              <NextLink href="https://t.me/AgniDEXCommunity" target="_blank">
                <img src="/newImages/launchpad/icon-community_telegram.svg" alt="icon" />
              </NextLink>
              <NextLink href="https://github.com/agni-protocol" target="_blank">
                <img src="/newImages/launchpad/icon-community_github.svg" alt="icon" />
              </NextLink>
            </div>
          </div>
        </div>
      </div>
      <hr className="divider" />
      <hr className="back" />
    </Wrapper>
  )
}

export default React.memo(FooterNew)
